export const ORDER_DETAILS = "ORDER_DETAILS"
export const ORDER_DESTROY = "ORDER_DESTROY"